import { render, staticRenderFns, recyclableRender, components } from "./u-badge.vue?vue&type=template&id=13728ffe&scoped=true&"
var renderjs
import script from "./u-badge.vue?vue&type=script&lang=js&"
export * from "./u-badge.vue?vue&type=script&lang=js&"
import style0 from "./u-badge.vue?vue&type=style&index=0&id=13728ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13728ffe",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-badge/u-badge.vue"
export default component.exports